// extracted by mini-css-extract-plugin
export default {"search-container":"Header_search-container__EjlE7","user":"Header_user__Kg1Sl","container-user":"Header_container-user__YBDvg","picture-container":"Header_picture-container__LRPBt"};